import { useContext } from "react";
import { PermissionsContext } from "../contexts/PermissionsContext";

/**
 * Global permission hook for checking permissions across all features
 * Returns permission map and helper functions
 *
 * NOTE: This hook now uses PermissionsContext to share permissions across all components.
 * Permissions are fetched once when PermissionsProvider mounts, preventing duplicate API calls.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { hasPermission, loading } = usePermissions();
 *
 *   if (loading) return <div>Loading...</div>;
 *
 *   const canEdit = hasPermission(MODULE_CODES.INVOICE, ACTION_CODES.UPDATE);
 *   return <button disabled={!canEdit}>Edit</button>;
 * }
 * ```
 */
export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error("usePermissions must be used within a PermissionsProvider");
  }
  return context;
};
